import { render, staticRenderFns } from "./OnlineTeaching.vue?vue&type=template&id=7508a14a&scoped=true&"
import script from "./OnlineTeaching.vue?vue&type=script&lang=js&"
export * from "./OnlineTeaching.vue?vue&type=script&lang=js&"
import style0 from "./OnlineTeaching.vue?vue&type=style&index=0&id=7508a14a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7508a14a",
  null
  
)

export default component.exports